<template>
  <component
    :is="tag"
    @click="onClick"
    :type="tag === 'button' && type"
    :to="to"
    class="button inline-flex items-center justify-center"
    :class="{ 'is-loading': loading }"
    :disabled="loading || disabled"
  >
    <slot />
  </component>
</template>

<script>
import baseButtonMixin from '@/mixins/baseButtonMixin';

export default {
  mixins: [baseButtonMixin],

  computed: {
    tag() {
      if (this.to) {
        return 'router-link';
      }
      return 'button';
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &.is-loading {
    color: transparent !important;
    pointer-events: none;
    position: relative;

    &::after {
      position: absolute;
      left: calc(50% - (1em * 0.5));
      top: calc(50% - (1em * 0.5));
      position: absolute !important;
      animation: spinAround 0.5s infinite linear;
      border: 2px solid #cbcbcb;
      border-radius: 9999px;
      border-right-color: transparent;
      border-top-color: transparent;
      content: '';
      display: block;
      height: 1em;
      width: 1em;
    }
  }
}
</style>
